import React, { useRef } from "react";
import classes from "./LinkCard.module.scss";

import linkCard1 from "../../assets/images/gerb.png";
import linkCard2 from "../../assets/images/lexuzcard.png";
import linkCard3 from "../../assets/images/linkCard1.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import leftIcon from "../../assets/icons/Left.png";
import rightIcon from "../../assets/icons/Right.png";
import { useLang } from "../../context/LanguageProvider";
import Language from '../../lang'

const LinkCard = () => {

    const [lang] = useLang();

    const ref = useRef(null)

    const settings = {
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 6,
        slidesToScroll: 1,


         responsive: [
        
        {
                settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
         {
          breakpoint: 700,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
        <div className={classes.position}>
            <div className={classes.link_card}>

                <div className={classes.useful_links}>
                    <p className={classes.slide_txt}>{Language[lang].titles.useFullLinks}</p>

                    <div className={classes.btn_wrapper}>
                        <button
                            onClick={() => ref.current.slickPrev()}
                        >
                            <img src={leftIcon} alt="" />
                        </button>
                        <button
                            onClick={() => ref.current.slickNext()}>
                            <img src={rightIcon} alt="" />
                        </button>
                    </div>
                </div>
            </div>

            <div className={classes.linkCard_wrap}>
                <Slider ref={ref} {...settings}>
                    <div className={classes.linkCard_wraper}>
                        <img src={linkCard1} alt="" className={classes.link_card} />
                        <p className={classes.link_txt1}>O‘zbekiston Respublikasi Prezidentining rasmiy veb-sayti</p>
                        <p className={classes.link_txt2}>
                            <a href="https://president.uz/oz">president.uz</a>
                        </p>
                    </div>

                    <div className={classes.linkCard_wraper}>
                        <img src={linkCard1} alt="" className={classes.link_card} />
                        <p className={classes.link_txt1}>O'zbekiston Respublikasi Adliya vazirligi</p>
                        <p className={classes.link_txt2}>
                            <a href="https://www.minjust.uz/uz/">minjust.uz</a>
                        </p>
                    </div>
                    <div className={classes.linkCard_wraper}>
                        <img src={linkCard2} alt="" className={classes.link_card} />
                        <p className={classes.link_txt1}>O‘zbekiston Respublikasi Qonun hujjatlari ma’lumotlari milliy bazasi</p>
                        <p className={classes.link_txt2}>
                            <a href="https://lex.uz/uz/">lex.uz</a>
                        </p>
                    </div>


                    <div className={classes.linkCard_wraper}>
                        <img src={linkCard1} alt="" className={classes.link_card} />
                        <p className={classes.link_txt1}>O'zbekiston Respublikasi Hukumat portali</p>
                        <p className={classes.link_txt2}>
                            <a href="https://www.gov.uz/uz">gov.uz</a>
                        </p>
                    </div>

                    <div className={classes.linkCard_wraper}>
                        <img src={linkCard3} alt="" className={classes.link_card} />
                        <p className={classes.link_txt1}>Milliy huquqiy internet portali</p>
                        <p className={classes.link_txt2}>
                            <a href="https://old.ima.uz/uz/">huquqiyportal.uz</a>
                        </p>
                    </div>


                    <div className={classes.linkCard_wraper}>
                        <img src={linkCard1} alt="" className={classes.link_card} />
                        <p className={classes.link_txt1}>Национальный правовой интернет-портал</p>
                        <p className={classes.link_txt2}>
                            <a href="huquqiyportal.uz">huquqiyportal.uz</a>
                        </p>
                    </div>

                    <div className={classes.linkCard_wraper}>
                        <img src={linkCard1} alt="" className={classes.link_card} />
                        <p className={classes.link_txt1}>Национальный правовой интернет-портал</p>
                        <p className={classes.link_txt2}>
                            <a href="huquqiyportal.uz">huquqiyportal.uz</a>
                        </p>
                    </div>
                </Slider>
            </div>
        </div>
    );
};

export default LinkCard;
